import { useTranslation } from '@/features/shared/composables/useTranslation'
import { ACCOUNT_TYPE } from '@/features/shared/constants/accountType'

const t = useTranslation()

export const overviewRoutes = [
  {
    path: 'overview',
    name: 'Overview',
    component: () => import('@/features/overview/views/Overview.vue'),
    meta: {
      mainRouteName: 'Overview',
      title: `${t('overview')} | Pour Now`,
      visibleAccountTypes: [ACCOUNT_TYPE.BRAND, ACCOUNT_TYPE.RETAILER],
    },
  },
]
